<template lang="html">
	<div class="omapi-subscribers-page omapi-subscribers-contacts">
		<div class="omapi-monsterleads">
			<monsterleads-contacts-no-subscribers v-if="showNoSubscribers"/>
			<monsterleads-contacts-table v-else/>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { pagination } from '@/monsterleads/mixins/pagination'

export default {
	mixins   : [ pagination ],
	computed : {
		...mapState('monsterleads', [ 'count', 'page', 'export' ]),
		...mapGetters([ 'connected', 'isFetched', 'shouldFetchUser' ]),
		...mapGetters('monsterleads', [ 'isDefaultQuery' ]),
		isLoading () {
			return this.shouldFetchUser || this.$store.getters.isLoading('monsterleads')
		},
		hasSubscribers () {
			return 0 < this.count
		},
		showNoSubscribers () {
			return !this.hasSubscribers &&
				!this.isLoading &&
				this.isDefaultQuery &&
				this.isFetched('monsterleads')
		},
	},
	methods : {
		...mapActions('monsterleads', {
			fetch : 'fetchLeads',
		}),
	},
}
</script>
<style lang="scss">
	@import '../../assets/scss/variables';
</style>
